export default __webpack_public_path__ + "static/icon-c211a70768574b6ae3a1aa4957cb2042.png";